"use strict";

(function () {
  document.querySelectorAll(".performance-category .performance-detail").forEach(function (e) {
    e.addEventListener("click", function (e) {
      var tmpl = e.target.closest(".performance-category").querySelector(".more-detail-template");
      document.body.classList.add("overflow-hidden");
      var dialog = document.createElement("div");
      dialog.setAttribute("class", "performance-detail-dialog");
      var content = document.createElement("div");
      content.innerHTML = tmpl.innerHTML;
      content.setAttribute("class", "performance-detail-content");
      var overlay = document.createElement("div");
      overlay.setAttribute("class", "performance-detail-overlay");
      overlay.addEventListener("click", function () {
        document.body.removeChild(dialog);
      });
      dialog.appendChild(overlay);
      dialog.appendChild(content);
      dialog.classList.add("active");
      content.style.transform = "translateX(120%)";
      var transitionend = function transitionend() {
        content.style.transform = "translateX(0)";
      };
      setTimeout(function () {
        content.style.transform = "translateX(0)";
      }, 0);
      dialog.querySelector(".close").addEventListener("click", function () {
        var transitionend = function transitionend() {
          dialog.classList.remove("active");
          document.body.removeChild(dialog);
          document.body.classList.remove("overflow-hidden");
        };
        content.addEventListener("transitionend", transitionend);
        content.style.transform = "translateX(120%)";
      });
      document.body.appendChild(dialog);
    });
  });
})();